export const storefrontPromotionDefaults = {
  poster_url: null,
  storefront_description: null,
  rules_mechanics: null,
  terms_conditions: null,
}

export const isSafePromotionPosterUrl = (value) => {
  if (typeof value !== 'string' || !/^https?:\/\/\S+$/i.test(value)) return false
  try {
    const url = new URL(value)
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password
  } catch {
    return false
  }
}

export const getStorefrontPromotionFields = (values) => ({
  poster_url: values.poster_url?.trim() || null,
  storefront_description: values.storefront_description?.trim() || null,
  rules_mechanics: values.rules_mechanics?.trim() || null,
  terms_conditions: values.terms_conditions?.trim() || null,
})

export const omitStorefrontDisplayControls = (values = {}) => Object.fromEntries(
  Object.entries(values).filter(([key]) => !['storefront_visible', 'display_pv', 'display_order'].includes(key))
)
